import App from "../app";
import NoFound from "../pages/notFound";
// console.log(routerList)
const router = [
  {
    // 一级路由配置
    path: "/",
    component: App,
    // 相关子路由配置
    children: [
      {
        path: "/creditSesame",
        component: resolve =>
          require(["@/pages/activity/creditSesame"], resolve)
      },
      {
        path: "/vipLottery",
        component: resolve => require(["@/pages/activity/vipLottery"], resolve),
        meta: {
          title: "会员专属"
        }
      },
      {
        path: "/collectTheCard",
        component: resolve =>
          require(["@/pages/activity/collectTheCard"], resolve),
        meta: {
          title: "扫星星过新年"
        }
      },
      {
        path: "/yearBill",
        component: resolve => require(["@/pages/activity/yearBill"], resolve),
        meta: {
          title: "年度账单"
        }
      },
      {
        path: "/activity/800degree/login",
        component: resolve =>
          require(["@/pages/activity/800degree/login"], resolve),
        meta: {
          title: "登录"
        }
      },
      {
        path: "/getCouponStandard",
        component: resolve =>
          require(["@/pages/activity/getCouponStandard"], resolve),
        meta: {
          title: "领券页面"
        }
      },
      {
        path: "/lotteryNewYear",
        component: resolve =>
          require(["@/pages/activity/lotteryNewYear"], resolve),
        meta: {
          title: "星星抽奖"
        }
      },
      {
        path: "/carbonTrace",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/index"], resolve),
        meta: {
          title: "碳迹公益"
        }
      },
      {
        path: "/carbonTrace/rule",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/rule"], resolve),
        meta: {
          title: "碳迹能量攻略"
        }
      },
      {
        path: "/carbonTrace/projectInfo",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/projectInfo"], resolve)
      },
      {
        path: "/carbonTrace/careElderInfo",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/careElderInfo"], resolve)
      },
      {
        path: "/carbonTrace/rareDisease",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/rareDisease"], resolve)
      },
      {
        path: "/carbonTrace/blueFire",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/blueFire"], resolve)
      },
      {
        path: "/carbonTrace/starLight",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/starLight"], resolve)
      },
      {
        path: "/carbonTrace/publicDetail",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/publicDetail"], resolve)
      },
      {
        path: "/carbonTrace/bag",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/bag"], resolve)
      },
      {
        path: "/carbonTrace/medal",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/medal"], resolve)
      },
      {
        path: "/carbonTrace/record",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/record"], resolve),
        meta: {
          title: "碳账户记录"
        }
      },
      {
        path: "/carbonTrace/welfare",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/welfare"], resolve),
        meta: {
          title: "福利中心"
        }
      },
      {
        path: "/carbonTrace/jointActive",
        component: resolve =>
          require(["@/pages/activity/carbonTrace/jointActive"], resolve),
        meta: {
          title: "星星充电与绿喵联合活动"
        }
      },
      {
        path: "/peakShaving",
        component: resolve =>
          require(["@/pages/activity/peakShaving/index"], resolve),
        meta: {
          title: "参与“星碳计划—有序充电”用户服务活动协议"
        }
      },
      {
        path: "/peakShaving/agreement",
        component: resolve =>
          require(["@/pages/activity/peakShaving/agreement"], resolve),
        meta: {
          title: "参与“星碳计划—有序充电”用户服务活动协议",
          keepAlive: true
        }
      },
      {
        path: "/cemtestQuestionnaire",
        component: () => import("@/pages/guanShan"),
        meta: {
          title: "问卷"
        }
      },
      {
        path: "/activity/starClass",
        component: () => import("@/pages/activity/starClass"),
        meta: {
          title: "星课堂"
        }
      },
      {
        path: "/activity/starClassNew",
        component: () => import("@/pages/activity/starClass/new"),
        meta: {
          title: "星课堂"
        }
      },
      {
        path: "/bindScAccount",
        component: () => import("@/pages/wxOfficialAccounts/index.vue"),
        meta: {
          title: "绑定星充账号"
        }
      },
      {
        path: "/unbindScAccount",
        component: () => import("@/pages/wxOfficialAccounts/unbind.vue"),
        meta: {
          title: "星充账号解绑"
        }
      },
      {
        path: "/bindScAccountFailure",
        component: () => import("@/pages/wxOfficialAccounts/failure.vue"),
        meta: {
          title: "绑定账号失败"
        }
      },
      {
        path: "/activity/chargeRedPackageNew",
        component: () =>
          import("@/pages/activity/chargeRedPackages/chargeRedPackagesNew"),
        meta: {
          title: "充电发红包"
        }
      },
      {
        path: "/activity/chargeRedPackageUser",
        component: () =>
          import("@/pages/activity/chargeRedPackages/chargeRedPackagesUserNew"),
        meta: {
          title: "充电发红包"
        }
      },
      {
        path: "/", // 转盘
        component: () => import("@/pages/activity/lotteryNewYear/index"),
        meta: {
          title: "星星抽奖"
        }
      },
      {
        path: "/starManager",
        component: () => import("@/pages/activity/starManager/index"),
        meta: {
          title: "星星掌柜"
        }
      },
      {
        path: "/managerlevel", // 星星掌柜等级
        component: resolve =>
          require(["@/pages/activity/starManager/managerLevel"], resolve),
        meta: {
          title: "星星掌柜"
        }
      },
      {
        path: "/myqrcode", // 星星掌柜加入店铺
        component: resolve =>
          require(["@/pages/activity/starManager/myqrcode"], resolve),
        meta: {
          title: "加入店铺"
        }
      },
      {
        path: "/exchange", // 星星掌柜兑换
        component: resolve =>
          require(["@/pages/activity/starManager/exchange"], resolve),
        meta: {
          title: "星星掌柜"
        }
      },
      {
        path: "/storeasset", // 星星掌柜店铺资产
        component: resolve =>
          require(["@/pages/activity/starManager/storeAsset"], resolve),
        meta: {
          title: "店铺资产"
        }
      },
      {
        path: "/silverdetail", // 星星掌柜银两明细
        component: resolve =>
          require(["@/pages/activity/starManager/silverDetail"], resolve),
        meta: {
          title: "银两明细"
        }
      },
      {
        path: "/viproster", // 星星掌柜贵宾花名册
        component: resolve =>
          require(["@/pages/activity/starManager/vipRoster"], resolve),
        meta: {
          title: "贵宾花名册"
        }
      },
      {
        path: "/vipindentity", // 星星掌柜贵宾身份
        component: resolve =>
          require(["@/pages/activity/starManager/vipIndentity"], resolve),
        meta: {
          title: "贵宾身份"
        }
      },
      {
        path: "/rule", // 星星掌柜规则
        component: resolve =>
          require(["@/pages/activity/starManager/rule"], resolve),
        meta: {
          title: "规则"
        }
      },
      {
        path: "/lowLivPromotion",
        component: resolve =>
          require(["@/pages/activity/lowLivPromotion"], resolve)
      },
      {
        path: "/lowLivPromotion/stationList",
        component: resolve =>
          require(["@/pages/activity/lowLivPromotion/stationList"], resolve),
        meta: {
          title: "场站列表"
        }
      },
      {
        path: "/lowLivPromotion/activityRule",
        component: resolve =>
          require(["@/pages/activity/lowLivPromotion/activityRule"], resolve),
        meta: {
          title: "活动规则"
        }
      },
      {
        path: "/question",
        component: () => import("@/pages/activity/questionnaireSecound/index"),
        meta: {
          title: "星星问卷"
        }
      },
      {
        path: "/questionnaireSubjects",
        component: () =>
          import("@/pages/activity/questionnaireSecound/subjectsIndex"),
        meta: {
          title: "星星问卷"
        }
      },
      {
        path: "/questionnaireSuccess",
        component: () =>
          import("@/pages/activity/questionnaireSecound/success"),
        meta: {
          title: "星星问卷"
        }
      },
      {
        path: "/useragreement",
        component: () => import("@/pages/userAgreement/index"),
        meta: {
          title: "用户协议"
        }
      },
      {
        path: "/teamUp",
        component: () => import("@/pages/activity/teamUpthird"),
        meta: {
          title: "组队打榜"
        }
      },
      {
        path: "/teamUp/rule",
        component: () => import("@/pages/activity/teamUpthird/rule"),
        meta: {
          title: "活动规则"
        }
      },
      {
        path: "/teamUp/share",
        component: () => import("@/pages/activity/teamUpthird/share"),
        meta: {
          title: "组队打榜"
        }
      },
      {
        path: "/teamUp/shareApp",
        component: resolve =>
          require(["@/pages/activity/teamUpthird/shareApp"], resolve),
        meta: {
          title: "组队打榜"
        }
      },
      {
        path: "/activity/wxRedirect",
        component: resolve => require(["@/pages/activity/redirect"], resolve),
        meta: {
          title: "组队打榜"
        }
      },
      {
        path: "/shakeIt",
        component: resolve => require(["@/pages/activity/shakeIt"], resolve),
        meta: {
          title: "摇一摇"
        }
      },
      {
        path: "/activity/shakeit/couponList",
        component: resolve =>
          require(["@/pages/activity/shakeIt/couponList"], resolve),
        meta: {
          title: "我的优惠券"
        }
      },
      {
        path: "/activity/shakeit/steal",
        component: resolve =>
          require(["@/pages/activity/shakeIt/steal"], resolve),
        meta: {
          title: "摇一摇 好运来"
        }
      },
      {
        path: "/activity/shakeit/pkAndShare",
        component: resolve =>
          require(["@/pages/activity/shakeIt/pkAndShare"], resolve),
        meta: {
          title: "摇一摇 好运来"
        }
      },
      {
        path: "/activity/shakeit/share",
        component: resolve =>
          require(["@/pages/activity/shakeIt/share"], resolve),
        meta: {
          title: "摇一摇 好运来"
        }
      },
      {
        path: "/activity/shakeit/exChange",
        component: resolve =>
          require(["@/pages/activity/shakeIt/exchange"], resolve),
        meta: {
          title: "摇一摇 好运来"
        }
      },
      {
        path: "/activity/shakeit/myWelfare",
        component: resolve =>
          require(["@/pages/activity/shakeIt/myWelfare"], resolve),
        meta: {
          title: "我的福利和权益"
        }
      },
      {
        path: "/activity/shakeit/popupAward",
        component: resolve =>
          require(["@/pages/activity/shakeIt/components/popupAward"], resolve),
        meta: {
          title: "摇一摇 好运来"
        }
      },
      {
        path: "/activity/rechargeSignin",
        component: resolve =>
          require(["@/pages/activity/rechargeSignin"], resolve),
        meta: {
          title: "充电签到"
        }
      },
      {
        path: "/activity/rechargeSignin/rule",
        component: resolve =>
          require(["@/pages/activity/rechargeSignin/rule"], resolve),
        meta: {
          title: "活动规则"
        }
      },
      {
        path: "/activity/creditPoints",
        component: resolve =>
          require(["@/pages/activity/creditPoints/index"], resolve),
        meta: {
          title: "支付分"
        }
      },
      {
        path: "/activity/liveBroadcast",
        // 直播首页
        component: resolve =>
          require(["@/pages/activity/liveBroadcast"], resolve),
        meta: {
          keepAlive: true,
          index: 1
        }
      },
      {
        path: "/activity/liveBroadcast/rule",
        // 直播规则
        component: resolve =>
          require(["@/pages/activity/liveBroadcast/rule"], resolve),
        meta: {
          title: "",
          index: 2
        }
      },
      {
        path: "/activity/liveBroadcast/pusher",
        // 直播推流
        component: resolve =>
          require(["@/pages/activity/liveBroadcast/pusher"], resolve),
        meta: {
          title: "",
          index: 3
        }
      },
      {
        path: "/activitys/redEnvelopeWar",
        component: resolve =>
          require(["@/pages/activity/redEnvelopeWar"], resolve)
      },
      {
        path: "/redpackets/share",
        component: resolve =>
          require(["@/pages/activity/redEnvelopeWar/share.vue"], resolve)
      },
      {
        path: "/activitys/myRed",
        component: resolve =>
          require(["@/pages/activity/redEnvelopeWar/myRed.vue"], resolve),
        meta: {
          title: "我的红包雨"
        }
      },
      {
        path: "/activity/800degree",
        component: resolve =>
          require(["@/pages/activity/800degree/index"], resolve),
        meta: {
          title: "充电送会员"
        }
      },
      {
        path: "/activity/800degree/record",
        component: resolve =>
          require(["@/pages/activity/800degree/record"], resolve),
        meta: {
          title: "电量记录"
        }
      },
      {
        path: "/activity/800degree/buyMember",
        component: resolve =>
          require(["@/pages/activity/800degree/buyMember"], resolve),
        meta: {
          title: "开通会员"
        }
      },
      {
        path: "/registerGift",
        component: resolve =>
          require(["@/pages/activity/registerGift"], resolve),
        meta: {
          title: "邀请好礼"
        }
      },
      {
        path: "/guangfaBank",
        component: resolve =>
          require(["@/pages/activity/guangfaBank/guangfa"], resolve),
        meta: {
          title: "广发银行活动"
        }
      },
      {
        path: "/lowCarbonReport",
        component: resolve =>
          require(["@/pages/activity/lowCarbonReport"], resolve),
        meta: {
          title: "低碳报告"
        }
      },
      {
        path: "/greenPower/share",
        component: resolve =>
          require(["@/pages/activity/greenPower/share"], resolve),
        meta: {
          title: "分享成就"
        }
      },
      {
        path: "/yearBill2022",
        component: resolve =>
          require(["@/pages/activity/yearBill2022/index"], resolve),
        meta: {
          title: "年度报告"
        }
      },
      {
        path: "/inviteNew",
        component: resolve =>
          require(["@/pages/activity/inviteNew/index"], resolve)
      },
      {
        path: "/citicBankAdv",
        component: resolve =>
          require(["@/pages/activity/citicBankAdv/index"], resolve)
      },
      {
        path: "/landing",
        component: resolve =>
          require(["@/pages/activity/landing/index"], resolve),
        meta: {
          title: "落地页"
        }
      }
    ]
  },
  // 无匹配路由重定向到404
  {
    path: "*",
    component: NoFound
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/starcharge/boot/router.js